<template>
  <div>
    <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link :to="{ name: 'role_management', params: { search: search, sName: this.$route.params.sName } }"
            class="btn btn-ptc1" tag="button">返回</router-link>
        </b-col>
        <b-col class="text-center title">系統管理 / 權限角色管理 / {{ title }}</b-col>
        <b-col>
          <div class="text-right">
            <button class="btn btn-save" type="submit" v-if="FunctionPermission > 1 && isEdit">儲存</button>
          </div>
        </b-col>
      </b-row>
      <div id="func-content">
        <b-card class="mb-2">
          <div style="padding-top: 0.75rem;">
            <validate tag="div">
              <b-form-group id="InputGroupName" label="角色名稱" label-for="InputName">
                <b-form-input id="InputName" name="InputName" type="text" required :disabled="!isEdit"
                  placeholder="請輸入角色名稱" v-model="roleName">
                </b-form-input>
                <field-messages name="InputName" show="$invalid && $submitted" class="text-danger">
                  <div slot="required">角色名稱為必填</div>
                </field-messages>
              </b-form-group>
            </validate>
            <table class="table b-table table-sm table-striped">
              <thead class="thead-default" align="center">
                <tr>
                  <th style="padding: 0.75rem" align="left">功能</th>
                  <th style="padding: 0.75rem">無權限</th>
                  <th style="padding: 0.75rem">唯讀</th>
                  <th style="padding: 0.75rem">儲存</th>
                  <th style="padding: 0.75rem">發佈/審核</th>
                  <th style="padding: 0.75rem">特殊權限</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding: 0.75rem" align="left">首頁廣告管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F04" value="0" :disabled="!isEdit" v-model="pick04">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F04" value="1" :disabled="!isEdit" v-model="pick04">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F04" value="2" :disabled="!isEdit" v-model="pick04">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F04" value="3" :disabled="!isEdit" v-model="pick04">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">行銷活動管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F05" value="0" :disabled="!isEdit" v-model="pick05">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F05" value="1" :disabled="!isEdit" v-model="pick05">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F05" value="2" :disabled="!isEdit" v-model="pick05">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F05" value="3" :disabled="!isEdit" v-model="pick05">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">會員集點任務管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F06" value="0" :disabled="!isEdit" v-model="pick06">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F06" value="1" :disabled="!isEdit" v-model="pick06">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F06" value="2" :disabled="!isEdit" v-model="pick06">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">滿意度調查管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F38" value="0" :disabled="!isEdit" v-model="pick38">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F38" value="1" :disabled="!isEdit" v-model="pick38">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F38" value="2" :disabled="!isEdit" v-model="pick38">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">餐點 DM 上傳</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F09" value="0" :disabled="!isEdit" v-model="pick09">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F09" value="1" :disabled="!isEdit" v-model="pick09">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F09" value="2" :disabled="!isEdit" v-model="pick09">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">商品券上架</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F10" value="0" :disabled="!isEdit" v-model="pick10">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F10" value="1" :disabled="!isEdit" v-model="pick10">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F10" value="2" :disabled="!isEdit" v-model="pick10">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F10" value="3" :disabled="!isEdit" v-model="pick10">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">商品券贈送</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F31" value="0" :disabled="!isEdit" v-model="pick31">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F31" value="1" :disabled="!isEdit" v-model="pick31">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F31" value="2" :disabled="!isEdit" v-model="pick31">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">POS商品管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F16" value="0" :disabled="!isEdit" v-model="pick16">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F16" value="1" :disabled="!isEdit" v-model="pick16">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F16" value="2" :disabled="!isEdit" v-model="pick16">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">POS套餐管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F17" value="0" :disabled="!isEdit" v-model="pick17">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F17" value="1" :disabled="!isEdit" v-model="pick17">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F17" value="2" :disabled="!isEdit" v-model="pick17">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">商品分類管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F18" value="0" :disabled="!isEdit" v-model="pick18">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F18" value="1" :disabled="!isEdit" v-model="pick18">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F18" value="2" :disabled="!isEdit" v-model="pick18">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">商品加購設定</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F19" value="0" :disabled="!isEdit" v-model="pick19">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F19" value="1" :disabled="!isEdit" v-model="pick19">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F19" value="2" :disabled="!isEdit" v-model="pick19">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">接單時段管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F20" value="0" :disabled="!isEdit" v-model="pick20">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F20" value="1" :disabled="!isEdit" v-model="pick20">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F20" value="2" :disabled="!isEdit" v-model="pick20">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">店休設定</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F34" value="0" :disabled="!isEdit" v-model="pick34">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F34" value="1" :disabled="!isEdit" v-model="pick34">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F34" value="2" :disabled="!isEdit" v-model="pick34">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">分店MID設定</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F27" value="0" :disabled="!isEdit" v-model="pick27">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F27" value="1" :disabled="!isEdit" v-model="pick27">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F27" value="2" :disabled="!isEdit" v-model="pick27">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">調味管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F28" value="0" :disabled="!isEdit" v-model="pick28">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F28" value="1" :disabled="!isEdit" v-model="pick28">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F28" value="2" :disabled="!isEdit" v-model="pick28">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">加料品管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F30" value="0" :disabled="!isEdit" v-model="pick30">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F30" value="1" :disabled="!isEdit" v-model="pick30">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F30" value="2" :disabled="!isEdit" v-model="pick30">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">訂單查詢</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F32" value="0" :disabled="!isEdit" v-model="pick32">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F32" value="1" :disabled="!isEdit" v-model="pick32">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F32" value="4" :disabled="!isEdit" v-model="pick32">
                      <span class="checkmark"></span>
                    </label>
                    <label class="containerLabel">退款</label>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">餐期查詢</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F35" value="0" :disabled="!isEdit" v-model="pick35">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F35" value="1" :disabled="!isEdit" v-model="pick35">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F35" value="2" :disabled="!isEdit" v-model="pick35">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">支付匯總數據</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F33" value="0" :disabled="!isEdit" v-model="pick33">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F33" value="1" :disabled="!isEdit" v-model="pick33">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F33" value="2" :disabled="!isEdit" v-model="pick33">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">會員查詢</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F07" value="0" :disabled="!isEdit" v-model="pick07">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F07" value="1" :disabled="!isEdit" v-model="pick07">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F07" value="2" :disabled="!isEdit" v-model="pick07">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F07" value="4" :disabled="!isEdit" v-model="pick07">
                      <span class="checkmark"></span>
                    </label>
                    <label class="containerLabel">會員刪除</label>
                    <label class="container">
                      <input type="radio" name="F07" value="5" :disabled="!isEdit" v-model="pick07">
                      <span class="checkmark"></span>
                    </label>
                    <label class="containerLabel">編輯會員推薦碼</label>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">會員補點</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F08" value="0" :disabled="!isEdit" v-model="pick08">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F08" value="1" :disabled="!isEdit" v-model="pick08">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F08" value="4" :disabled="!isEdit" v-model="pick08">
                      <span class="checkmark"></span>
                    </label>
                    <label class="containerLabel">補點</label>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">推播訊息</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F36" value="0" :disabled="!isEdit" v-model="pick36">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F36" value="1" :disabled="!isEdit" v-model="pick36">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F36" value="2" :disabled="!isEdit" v-model="pick36">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">廣告點擊率分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F11" value="0" :disabled="!isEdit" v-model="pick11">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F11" value="1" :disabled="!isEdit" v-model="pick11">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F11" value="2" :disabled="!isEdit" v-model="pick11">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">點數分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F12" value="0" :disabled="!isEdit" v-model="pick12">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F12" value="1" :disabled="!isEdit" v-model="pick12">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F12" value="2" :disabled="!isEdit" v-model="pick12">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">點數兌換券分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F13" value="0" :disabled="!isEdit" v-model="pick13">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F13" value="1" :disabled="!isEdit" v-model="pick13">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F13" value="2" :disabled="!isEdit" v-model="pick13">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">活動任務分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F14" value="0" :disabled="!isEdit" v-model="pick14">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F14" value="1" :disabled="!isEdit" v-model="pick14">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F14" value="2" :disabled="!isEdit" v-model="pick14">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">會員使用優惠券分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F21" value="0" :disabled="!isEdit" v-model="pick21">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F21" value="1" :disabled="!isEdit" v-model="pick21">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F21" value="2" :disabled="!isEdit" v-model="pick21">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">APP訂購餐點分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F22" value="0" :disabled="!isEdit" v-model="pick22">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F22" value="1" :disabled="!isEdit" v-model="pick22">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F22" value="2" :disabled="!isEdit" v-model="pick22">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">會員APP訂餐分析</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F25" value="0" :disabled="!isEdit" v-model="pick25">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F25" value="1" :disabled="!isEdit" v-model="pick25">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F25" value="2" :disabled="!isEdit" v-model="pick25">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">地區訂購餐點查詢</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F26" value="0" :disabled="!isEdit" v-model="pick26">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F26" value="1" :disabled="!isEdit" v-model="pick26">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F26" value="2" :disabled="!isEdit" v-model="pick26">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">第三方支付訂單查詢</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F23" value="0" :disabled="!isEdit" v-model="pick23">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F23" value="1" :disabled="!isEdit" v-model="pick23">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F23" value="2" :disabled="!isEdit" v-model="pick23">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">支付使用數據統計</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F24" value="0" :disabled="!isEdit" v-model="pick24">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F24" value="1" :disabled="!isEdit" v-model="pick24">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F24" value="2" :disabled="!isEdit" v-model="pick24">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">常見問題設定</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F15" value="0" :disabled="!isEdit" v-model="pick15">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F15" value="1" :disabled="!isEdit" v-model="pick15">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F15" value="2" :disabled="!isEdit" v-model="pick15">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">權限角色管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F01" value="0" :disabled="!isEdit" v-model="pick01">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F01" value="1" :disabled="!isEdit" v-model="pick01">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F01" value="2" :disabled="!isEdit" v-model="pick01">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">使用者管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F02" value="0" :disabled="!isEdit" v-model="pick02">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F02" value="1" :disabled="!isEdit" v-model="pick02">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F02" value="2" :disabled="!isEdit" v-model="pick02">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">Mail Server 管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F03" value="0" :disabled="!isEdit" v-model="pick03">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F03" value="1" :disabled="!isEdit" v-model="pick03">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F03" value="2" :disabled="!isEdit" v-model="pick03">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">App版本管理</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F29" value="0" :disabled="!isEdit" v-model="pick29">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F29" value="1" :disabled="!isEdit" v-model="pick29">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F29" value="2" :disabled="!isEdit" v-model="pick29">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding: 0.75rem" align="left">預購</td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F37" value="0" :disabled="!isEdit" v-model="pick37">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="container">
                      <input type="radio" name="F37" value="1" :disabled="!isEdit" v-model="pick37">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </vue-form>
  </div>
</template>

<script>
// for API_URL
import axios from 'axios'
import { API_URL } from '../../store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
// 功能權限function
import { getFunctionPermission } from '../../js/LoginUserFunction.js'

miniToastr.init()

export default {
  name: 'HelloWorld',
  data() {
    return {
      isEdit: false,
      roleName: '',
      pick01: 0,
      pick02: 0,
      pick03: 0,
      pick04: 0,
      pick05: 0,
      pick06: 0,
      pick07: 0,
      pick08: 0,
      pick09: 0,
      pick10: 0,
      pick11: 0,
      pick12: 0,
      pick13: 0,
      pick14: 0,
      pick15: 0,
      pick16: 0,
      pick17: 0,
      pick18: 0,
      pick19: 0,
      pick20: 0,
      pick21: 0,
      pick22: 0,
      pick23: 0,
      pick24: 0,
      pick25: 0,
      pick26: 0,
      pick27: 0,
      pick28: 0,
      pick29: 0,
      pick30: 0,
      pick31: 0,
      pick32: 0,
      pick33: 0,
      pick34: 0,
      pick35: 0,
      pick36: 0,
      pick37: 0,
      pick38: 0,
      formstate: {}, // 驗證用
      FunctionPermission: 0, // 功能權限
      title: '',
      search: {} // 記錄查詢條件
    }
  },
  created() {
    var params = this.$route.params
    if (params.roleId === undefined) {
      this.$router.push({ name: 'role_management' })
      return
    }
    this.search = params.search
    this.FunctionPermission = getFunctionPermission('F01') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 1 && this.$route.params.isEdit === true) {
      this.title = '修改權限角色'
    } else {
      this.title = '權限角色明細'
      if (this.FunctionPermission === 1) {
        this.$router.push({ name: 'role_management' })
        return
      } else if (this.FunctionPermission < 1) {
        this.$router.push({ name: 'name' })
        return
      }
    }
    this.load()
  },
  methods: {
    onSubmit: function () {
      if (this.formstate.$invalid) {
      } else {
        this.edit()
      }
    },
    load() {
      this.isEdit = this.$route.params.isEdit
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/roles/functionlist', {
        id: this.$route.params.roleId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var p01 = 0
            var p02 = 0
            var p03 = 0
            var p04 = 0
            var p05 = 0
            var p06 = 0
            var p07 = 0
            var p08 = 0
            var p09 = 0
            var p10 = 0
            var p11 = 0
            var p12 = 0
            var p13 = 0
            var p14 = 0
            var p15 = 0
            var p16 = 0
            var p17 = 0
            var p18 = 0
            var p19 = 0
            var p20 = 0
            var p21 = 0
            var p22 = 0
            var p23 = 0
            var p24 = 0
            var p25 = 0
            var p26 = 0
            var p27 = 0
            var p28 = 0
            var p29 = 0
            var p30 = 0
            var p31 = 0
            var p32 = 0
            var p33 = 0
            var p34 = 0
            var p35 = 0
            var p36 = 0
            var p37 = 0
            var p38 = 0
            response.data.data.forEach(function (arrRole, Index) {
              if (arrRole.functionId === 1) {
                p01 = arrRole.functionPermission
              }
              if (arrRole.functionId === 2) {
                p02 = arrRole.functionPermission
              }
              if (arrRole.functionId === 3) {
                p03 = arrRole.functionPermission
              }
              if (arrRole.functionId === 4) {
                p04 = arrRole.functionPermission
              }
              if (arrRole.functionId === 5) {
                p05 = arrRole.functionPermission
              }
              if (arrRole.functionId === 6) {
                p06 = arrRole.functionPermission
              }
              if (arrRole.functionId === 7) {
                p07 = arrRole.functionPermission
              }
              if (arrRole.functionId === 8) {
                p08 = arrRole.functionPermission
              }
              if (arrRole.functionId === 9) {
                p09 = arrRole.functionPermission
              }
              if (arrRole.functionId === 10) {
                p10 = arrRole.functionPermission
              }
              if (arrRole.functionId === 11) {
                p11 = arrRole.functionPermission
              }
              if (arrRole.functionId === 12) {
                p12 = arrRole.functionPermission
              }
              if (arrRole.functionId === 13) {
                p13 = arrRole.functionPermission
              }
              if (arrRole.functionId === 14) {
                p14 = arrRole.functionPermission
              }
              if (arrRole.functionId === 15) {
                p15 = arrRole.functionPermission
              }
              if (arrRole.functionId === 16) {
                p16 = arrRole.functionPermission
              }
              if (arrRole.functionId === 17) {
                p17 = arrRole.functionPermission
              }
              if (arrRole.functionId === 18) {
                p18 = arrRole.functionPermission
              }
              if (arrRole.functionId === 19) {
                p19 = arrRole.functionPermission
              }
              if (arrRole.functionId === 20) {
                p20 = arrRole.functionPermission
              }
              if (arrRole.functionId === 21) {
                p21 = arrRole.functionPermission
              }
              if (arrRole.functionId === 22) {
                p22 = arrRole.functionPermission
              }
              if (arrRole.functionId === 23) {
                p23 = arrRole.functionPermission
              }
              if (arrRole.functionId === 24) {
                p24 = arrRole.functionPermission
              }
              if (arrRole.functionId === 25) {
                p25 = arrRole.functionPermission
              }
              if (arrRole.functionId === 26) {
                p26 = arrRole.functionPermission
              }
              if (arrRole.functionId === 27) {
                p27 = arrRole.functionPermission
              }
              if (arrRole.functionId === 28) {
                p28 = arrRole.functionPermission
              }
              if (arrRole.functionId === 29) {
                p29 = arrRole.functionPermission
              }
              if (arrRole.functionId === 30) {
                p30 = arrRole.functionPermission
              }
              if (arrRole.functionId === 31) {
                p31 = arrRole.functionPermission
              }
              if (arrRole.functionId === 32) {
                p32 = arrRole.functionPermission
              }
              if (arrRole.functionId === 33) {
                p33 = arrRole.functionPermission
              }
              if (arrRole.functionId === 34) {
                p34 = arrRole.functionPermission
              }
              if (arrRole.functionId === 35) {
                p35 = arrRole.functionPermission
              }
              if (arrRole.functionId === 36) {
                p36 = arrRole.functionPermission
              }
              if (arrRole.functionId === 37) {
                p37 = arrRole.functionPermission
              }
              if (arrRole.functionId === 38) {
                p38 = arrRole.functionPermission
              }
            })
            this.pick01 = p01
            this.pick02 = p02
            this.pick03 = p03
            this.pick04 = p04
            this.pick05 = p05
            this.pick06 = p06
            this.pick07 = p07
            this.pick08 = p08
            this.pick09 = p09
            this.pick10 = p10
            this.pick11 = p11
            this.pick12 = p12
            this.pick13 = p13
            this.pick14 = p14
            this.pick15 = p15
            this.pick16 = p16
            this.pick17 = p17
            this.pick18 = p18
            this.pick19 = p19
            this.pick20 = p20
            this.pick21 = p21
            this.pick22 = p22
            this.pick23 = p23
            this.pick24 = p24
            this.pick25 = p25
            this.pick26 = p26
            this.pick27 = p27
            this.pick28 = p28
            this.pick29 = p29
            this.pick30 = p30
            this.pick31 = p31
            this.pick32 = p32
            this.pick33 = p33
            this.pick34 = p34
            this.pick35 = p35
            this.pick36 = p36
            this.pick37 = p37
            this.pick38 = p38
            this.roleName = this.$route.params.roleName
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    edit() {
      var arrAll = []
      arrAll.push({
        functionId: 1,
        functionPermission: Number(this.pick01)
      })
      arrAll.push({
        functionId: 2,
        functionPermission: Number(this.pick02)
      })
      arrAll.push({
        functionId: 3,
        functionPermission: Number(this.pick03)
      })
      arrAll.push({
        functionId: 4,
        functionPermission: Number(this.pick04)
      })
      arrAll.push({
        functionId: 5,
        functionPermission: Number(this.pick05)
      })
      arrAll.push({
        functionId: 6,
        functionPermission: Number(this.pick06)
      })
      arrAll.push({
        functionId: 7,
        functionPermission: Number(this.pick07)
      })
      arrAll.push({
        functionId: 8,
        functionPermission: Number(this.pick08)
      })
      arrAll.push({
        functionId: 9,
        functionPermission: Number(this.pick09)
      })
      arrAll.push({
        functionId: 10,
        functionPermission: Number(this.pick10)
      })
      arrAll.push({
        functionId: 11,
        functionPermission: Number(this.pick11)
      })
      arrAll.push({
        functionId: 12,
        functionPermission: Number(this.pick12)
      })
      arrAll.push({
        functionId: 13,
        functionPermission: Number(this.pick13)
      })
      arrAll.push({
        functionId: 14,
        functionPermission: Number(this.pick14)
      })
      arrAll.push({
        functionId: 15,
        functionPermission: Number(this.pick15)
      })
      arrAll.push({
        functionId: 16,
        functionPermission: Number(this.pick16)
      })
      arrAll.push({
        functionId: 17,
        functionPermission: Number(this.pick17)
      })
      arrAll.push({
        functionId: 18,
        functionPermission: Number(this.pick18)
      })
      arrAll.push({
        functionId: 19,
        functionPermission: Number(this.pick19)
      })
      arrAll.push({
        functionId: 20,
        functionPermission: Number(this.pick20)
      })
      arrAll.push({
        functionId: 21,
        functionPermission: Number(this.pick21)
      })
      arrAll.push({
        functionId: 22,
        functionPermission: Number(this.pick22)
      })
      arrAll.push({
        functionId: 23,
        functionPermission: Number(this.pick23)
      })
      arrAll.push({
        functionId: 24,
        functionPermission: Number(this.pick24)
      })
      arrAll.push({
        functionId: 25,
        functionPermission: Number(this.pick25)
      })
      arrAll.push({
        functionId: 26,
        functionPermission: Number(this.pick26)
      })
      arrAll.push({
        functionId: 27,
        functionPermission: Number(this.pick27)
      })
      arrAll.push({
        functionId: 28,
        functionPermission: Number(this.pick28)
      })
      arrAll.push({
        functionId: 29,
        functionPermission: Number(this.pick29)
      })
      arrAll.push({
        functionId: 30,
        functionPermission: Number(this.pick30)
      })
      arrAll.push({
        functionId: 31,
        functionPermission: Number(this.pick31)
      })
      arrAll.push({
        functionId: 32,
        functionPermission: Number(this.pick32)
      })
      arrAll.push({
        functionId: 33,
        functionPermission: Number(this.pick33)
      })
      arrAll.push({
        functionId: 34,
        functionPermission: Number(this.pick34)
      })
      arrAll.push({
        functionId: 35,
        functionPermission: Number(this.pick35)
      })
      arrAll.push({
        functionId: 36,
        functionPermission: Number(this.pick36)
      })
      arrAll.push({
        functionId: 37,
        functionPermission: Number(this.pick37)
      })
      arrAll.push({
        functionId: 38,
        functionPermission: Number(this.pick38)
      })
      console.log(arrAll)
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/roles/update', {
        roleID: this.$route.params.roleId,
        roleName: this.roleName,
        Data: arrAll
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.$router.push({ name: 'role_management', params: { search: this.search, sName: this.$route.params.sName } }) // 分頁處理 : 回 上一頁列表該去的分頁
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ui-breadcrumb {
  margin-bottom: 0;
}

/* 以下為rodio button */
.container {
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 50%;
  left: calc(50% - 10px);
  ;
  height: 20px;
  width: 20px;
  background-color: #ccc;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input~.checkmark {
  background-color: #919191;
}

/* When the radio button is checked, add a blue background */
.container input:checked~.checkmark {
  background-color: #519b39;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.containerLabel {
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/roleManagementEdit.vue